
<template>
  <div style="padding:20px;background:#fff;border-radius:10px;">
    <exportDate v-if="showExport" @hideExport="hideExport1" :condition="condition" :provinCode="registProvcode" :provinceName="priviceName" :moduleName="moduleName"/>
    <div>
      <div class="top-div">
        <el-col :span="15">
            <span class="demonstration">{{priviceName}}各地区货运平台车辆行驶里程分布统计 - </span>
            <!--el-date-picker
              v-model="monTime"
              type="month"
              placeholder="选择月"
              @change="changeTime"
              value-format="yyyy-MM"
            ></el-date-picker-->
            <dimension-popover :isMapValue="true" :dimObj="dimObj" :change="changeDimension" :showBottomButton="false" :isItemBindClick="true" />
        </el-col>
        <el-col :span="9">
          <el-button style="float: right;" v-show="hideExport"  @click="exprotData">导出</el-button>
          <el-button style="float: right;margin-right: 10px;" @click="goback" v-if="utype!=2">返回上一级</el-button>
          <el-select v-model="fuelType" @change="changeFuelType" style="width:150px;float: right;" placeholder="请选择燃油类型">
            <el-option
              v-for="(item,index) in fuelTypeList"
              :label="item.label"
              :value="item.value"
              :key="index"
            />
          </el-select>
        </el-col>
        </div>
        <div style="color:red;margin:10px 0">
          *数据统计口径见下方说明：
        </div>
         <el-table ref="singleTable"  :data="tableData" :max-height="tableHeight1" stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号 "></el-table-column>
        <el-table-column property="cityName" label="运营地区" align="center"></el-table-column>
        <el-table-column property="" label="统计维度" align="center"  width="150">
         <template slot-scope="scope">
            <div class="tabhgt" >
              车辆注册地区
            </div>
            <div class="tabhgt tabbor">
              车辆运营地区
            </div>
          </template>
        </el-table-column>
        <el-table-column property="totalCout" label="运营车辆数"   align="center">
          <template slot-scope="scope">
             <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].totalCout:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].totalCout:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="first" align="center" :label="barTitle[0]">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].first:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].first:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="second" :label="barTitle[1]" align="center">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].second:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].second:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="three" :label="barTitle[2]"  align="center" width="160">
          <template slot-scope="scope">
             <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].three:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].three:0)}}
            </div>
          </template>
        </el-table-column>
        <el-table-column property="four" :label="barTitle[3]"  align="center" width="160">
          <template slot-scope="scope">
            <div class="tabhgt">
              {{ format(scope.row.records?scope.row.records[0].four:0)}}
            </div>
            <div class="tabhgt tabbor">
              {{ format(scope.row.records?scope.row.records[1].four:0)}}
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>
    <div class="bottom-top">
      <h4>
        <img src="../../../../assets/images/title.png">
        <span>说明</span>
      </h4>
      <div>1、里程区间：以当月有行驶记录的车辆月度运行里程总和进行划分；</div>
      <div>2、按车辆注册地区：该地区入网车辆在全国运营的车辆数；</div>
      <div>3、按车辆运营地区：全国货运平台车辆在该地区运营的车辆数（注：在统计时间内，如这辆车在该省存在跨地区运营，则每途经一个地区均会在该地区计为1辆，
        所以会存在省内各地区运营车辆数之和大于该省运营车辆数的情况）。</div>
    </div>
  </div>
</template>
<script>
import http from '@/api/freight'
//import exportDate from '@/components/exportDate'
import exportDate from '@/components/exportDate/daphne/dialog.vue'
import Cookies from 'js-cookie'
import { hideExport } from '@/utils/tools'
import { getFuelTypeList , getFuelTypeCode} from '@/utils/dictionary'
import get from 'lodash/get'
import set from 'lodash/set'
import each from 'lodash/each'
import dimensionPopover from '@/components/exportDate/daphne/popover.vue'
let i = 0
// var now = new Date()
// now.setMonth(now.getMonth() - 1)
export default {
  components: {
    exportDate,
    dimensionPopover,
  },
  data() {
    let fuelTypeList = getFuelTypeList();

    let dimsTitle=[
        ["1千公里以下运营车辆数","1千(含)-5千公里运营车辆数","5千(含)-1万公里运营车辆数","1万公里(含)以上运营车辆数"],

        ["3千公里以下运营车辆数","3千(含)-1万5千公里运营车辆数","1万5千(含)-3万公里运营车辆数","3万公里(含)以上运营车辆数"],

        ["6千公里以下运营车辆数","6千(含)-3万公里运营车辆数","3万(含)-6万公里运营车辆数","6万公里(含)以上运营车辆数"],

        ["1.2万公里以下运营车辆数","1.2万(含)-6万公里运营车辆数","6万(含)-12万公里运营车辆数","12万公里(含)以上运营车辆数"],

      ];
    let barTitle=[];
    let index=get(this,"dimObj.type","0");
    let arr = get(dimsTitle,index,[]);
    each(arr,label=>{
      barTitle.push(label)
    });
    return {
      fuelTypeList,
      hideExport:hideExport,
      i: 0,
      tableHeight1:this.tableHeight+150,
      monTime: '', // 默认月份
      tableData: [],
      showExport:false,//控制批量导出
      moduleName:'vehicleCountCity',
      time:'',
      condition:"mileage",
      utype:0,
      dimsTitle,
      barTitle,
    }
  },
  props:{
     priviceName: {
      default: () => {
        return ''
      },
      type: String
    },
    registProvcode: {
      default: () => {
        return ''
      },
      type: String
    },
    value: {
      default: () => {
        return ''
      },
      type: String
    },
    fuelType: {
      default: () => {
        return ''
      },
      type: String
    },
    dimObj: {
      default: () => {
        return {
          year: "2022",
          month: "02",
          type: "0",
        }
      },
      type: Object
    },
  },
  watch: {
  },
  created() {
  },
  mounted(){
    this.utype = Cookies.get('userType')
    this.monTime=this.value
    // this.time=this.utype!=2?this.value:'-'
    this.time=this.utype!=2?this.value:this.dimObj.year+'-'+this.dimObj.month
    this.getDatails()
   
  },
  methods:{
    changeFuelType(){
      this.getDatails()
    },
    format(num) {
      if(num==null||num==undefined)return 0;
      var reg = /\d{1,3}(?=(\d{3})+$)/g
      return (num + '').replace(reg, '$&,')
    },
     // 取消导出
    hideExport1(){
      this.showExport=false
    },
    exprotData(){
      this.showExport=true
    },
    getDatails(){
      var that=this
      let energyType = getFuelTypeCode(this.fuelType)
      let type = get(this,"dimObj.type","0")
      that.tableData=[]
      var month=this.month
      if(month>9){
        month=this.month
      }else{
        month="0"+this.month
      }
       http
        .getCityDataList({
          provinCode:that.registProvcode,
          registMonth:that.time.split("-")[1],
          registYear:that.time.split("-")[0],
          condition:that.condition  || "mileage",
          energyType,
          type,
        })
        .then(e => {
          that.tableData=e.data.tPageUtil
          let tt = e.data.time
          that.monTime = Number(tt.substr(0, 4))+'-'+Number(tt.substr(-2));
          that.month = Number(tt.substr(-2));
          that.year = Number(tt.substr(0, 4)) 
        })
    },
    initMonth(num) {
      let newNum = num + 1
      return newNum < 10 ? '0' + newNum : newNum + ''
    },
    changeDimension(e){
      if(e.isOk){
        let type = e.type;
        let arr = get(this,["dimsTitle",type],[]);
        each(arr,(label,index)=>{
          set(this,["barTitle",index],label);
        });
        this.monTime = e.year+"-"+e.month;
        this.dimObj.year = e.year;
        this.dimObj.month = e.month;
        this.dimObj.type = type;
        this.changeTime();
      }
    },
    changeTime() {
      let that = this
      let time = that.monTime
      let arr = time.split('-')
      that.time = arr[0] + '-' + arr[1]
      that.getDatails()
    },
    goback(){
      this.$emit("closeDetails")
    },
  }
}
</script>
<style scoped>
.demonstration{
  font-weight: bold
}
.tabhgt{
  height: 40px;
  line-height: 35px;
}
.tabbor{
  border-top: 1px solid #ebeef5;
  line-height: 50px;
}
.el-table td .cell{
  padding-right: 0 !important;
  padding-left: 0 !important;
}

</style>
